(function() {
  'use strict';

  angular
    .module('admin.logs.service', [])
    .factory('LogsService', LogsService);

  /** @ngInject */
  function LogsService($http, $q, API) {

    function getProductLogUser(userId){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/users/' +  userId + '/product_logs')
          .success(defered.resolve);

        return defered.promise;
    }


    return{
       getProductLogUser: getProductLogUser
    };

  }

})();
